import React, { useState, useEffect } from 'react';

const Button = (props) => {



    return (
        <React.Fragment>
            <div className="grid">



                <button onClick={props.toggleFavoriteStatusHandler} className="colorful-button dark" style={{ fontFamily: "BYekan" }} >
                    <div className="wrapper">
                        <span>

                            {
                                props.itemIsFavorite ? ("حذف از علاقه مندی ها") : ("افزودن به علاقه مندی ها")
                            }
                        </span>
                        <div className="circle circle-12"></div>
                        <div className="circle circle-11"></div>
                        <div className="circle circle-10"></div>
                        <div className="circle circle-9"></div>
                        <div className="circle circle-8"></div>
                        <div className="circle circle-7"></div>
                        <div className="circle circle-6"></div>
                        <div className="circle circle-5"></div>
                        <div className="circle circle-4"></div>
                        <div className="circle circle-3"></div>
                        <div className="circle circle-2"></div>
                        <div className="circle circle-1"></div>
                    </div>
                </button>

            </div>




        </React.Fragment>

    )
}
export default Button;